<app-alerts />

<app-admin-cosmetic-details-form
  (submitClickEvent)="handleSubmitClickEvent($event)" />
